module.exports = {"320826100":"涟城镇","320826101":"高沟镇","320826102":"唐集镇","320826103":"保滩镇","320826104":"大东镇","320826105":"五港镇","320826106":"梁岔镇","320826107":"石湖镇","320826108":"朱码镇","320826109":"岔庙镇","320826110":"东胡集镇","320826111":"南集镇","320826112":"义兴镇","320826113":"成集镇","320826114":"红窑镇","320826115":"陈师镇","320826116":"前进镇","320826200":"徐集乡","320826201":"黄营乡","320826400":"杨口","320826401":"方渡","320826402":"南禄","320826403":"小李集工业园区管委会","320826404":"河网","320826405":"时码","320826406":"北集","320826407":"灰墩","320826408":"余圩","320826409":"浅集","320826410":"机场产业园区管委会","320826411":"麻垛农业开发区管委会","320826412":"经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320826.json
// module id = 829
// module chunks = 0